import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { ToastContainer, toast } from "react-toastify";

const SelfAppraisalEvaluate = () => {
  const { requestId } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [step, setStep] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  /* ================= FETCH ================= */
  useEffect(() => {
    if (!requestId) {
      toast.error("Invalid appraisal request");
      history.push("/SelfAppraisalList");
      return;
    }

    axios
      .get(`${API_BASE_URL}/self-appraisal/${requestId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => {
        if (res.data.expired) {
          toast.error("Appraisal expired");
          history.push("/SelfAppraisalList");
          return;
        }

        if (res.data.is_answerd === 1) {
          history.push("/SelfAppraisalList");
          return;
        }

        setQuestions(res.data.questions || []);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Failed to load appraisal");
        history.push("/SelfAppraisalList");
      });
  }, [requestId, history]);

  /* ================= SUBMIT ================= */
  const submit = () => {
    if (Object.keys(answers).length !== questions.length) {
      toast.error("Please answer all questions");
      return;
    }

    setSubmitting(true);

    axios
      .post(
        `${API_BASE_URL}/self-appraisal/submit`,
        {
          request_id: requestId,
          answers: Object.values(answers),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then(() => {
        toast.success("Self appraisal submitted");
        setTimeout(() => history.push("/SelfAppraisalList"), 1200);
      })
      .catch(() => {
        toast.error("Submission failed");
        setSubmitting(false);
      });
  };

  /* ================= UI ================= */
  if (loading) {
    return <div className="card p-4 text-center">Loading...</div>;
  }

  const current = questions[step];

  return (
    <div className="card">
     <ToastContainer position="bottom-right" />

      <div className="card-header text-center">
        <h5>{current.question_title}</h5>
        <small>
          Question {step + 1} / {questions.length}
        </small>
      </div>

      <div className="card-body">
        {current.options.map((opt) => (
          <div key={opt.value_id} className="form-check mb-2">
            <input
              type="radio"
              className="form-check-input"
              name={`q_${current.question_id}`}
              checked={
                answers[current.question_id]?.option_id === opt.value_id
              }
              onChange={() =>
                setAnswers({
                  ...answers,
                  [current.question_id]: {
                    question_id: current.question_id,
                    option_id: opt.value_id,
                    score: opt.score,
                    comment: "",
                  },
                })
              }
            />
            <label className="form-check-label">
              {opt.value_title}
            </label>
          </div>
        ))}
      </div>

      <div className="card-footer d-flex justify-content-between">
        <button
          className="btn btn-secondary"
          disabled={step === 0}
          onClick={() => setStep(step - 1)}
        >
          Previous
        </button>

        {step < questions.length - 1 ? (
          <button
            className="btn btn-primary"
            onClick={() => {
              if (!answers[current.question_id]) {
                toast.error("Please select an option");
                return;
              }
              setStep(step + 1);
            }}
          >
            Next
          </button>
        ) : (
          <button
            className="btn btn-primary"
            disabled={submitting}
            onClick={submit}
          >
            {submitting ? "Submitting..." : "Submit"}
          </button>
        )}
      </div>
    </div>
  );
};

export default SelfAppraisalEvaluate;
